module.exports = __webpack_public_path__ + "img/logo.a8ea37c8.png";